var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Admin/Ico/User Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.8926258%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A973",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF863F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin/Ico/User-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2466125,15.8 C16.208485,15.8 15.3300851,15.4694475 14.6113821,14.8083315 C13.8926791,14.1472192 13.5333333,13.3444493 13.5333333,12.4 C13.5333333,11.4555507 13.8926791,10.6527808 14.6113821,9.99166848 C15.3300851,9.33055253 16.208485,9 17.2466125,9 C18.2448109,9 19.1032482,9.33055253 19.8219512,9.99166848 C20.5406542,10.6527808 20.9,11.4555507 20.9,12.4 C20.9,13.3444493 20.5406542,14.1472192 19.8219512,14.8083315 C19.1032482,15.4694475 18.2448109,15.8 17.2466125,15.8 Z M11.8923611,19.7620968 C13.8206107,19.0095827 15.6701313,18.6333333 17.4409722,18.6333333 C19.2118131,18.6333333 21.0810084,19.0095827 23.0486111,19.7620968 C25.0162138,20.5146108 26,21.5245456 26,22.7919355 L26,26 L9,26 L9,22.7919355 C9,21.5245456 9.9641108,20.5146108 11.8923611,19.7620968 Z",
    id: "Page-1",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersColor);
export default __webpack_public_path__ + "static/media/users-color.f298d6dae01906b7c97bb5512bfce751.svg";
export { ForwardRef as ReactComponent };